export default  {"src":"/_next/static/image/public/assets/icons/close.b2ec58b1fe6fb9bb107e63cc06ab8525.svg","height":15,"width":15};